import { useEffect } from "react";

export function useSmoothScroll(): void {
  useEffect(() => {
    const scrollToHash = (hash: string, behavior: ScrollBehavior): boolean => {
      if (!hash || !hash.startsWith("#")) return false;
      const el: Element | null = document.querySelector(hash);
      if (!el) return false;
      (el as HTMLElement).scrollIntoView({ behavior, block: "start" });
      return true;
    };

    const clickHandler = (e: MouseEvent): void => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const anchor = target.closest("a[href^='#']") as HTMLAnchorElement | null;
      if (!anchor) return;
      const hash: string | null = anchor.getAttribute("href");
      if (!hash || !hash.startsWith("#")) return;
      e.preventDefault();
      const didScroll: boolean = scrollToHash(hash, "smooth");
      if (!didScroll) return;
      try {
        window.history.pushState(null, "", hash);
      } catch {
        window.location.hash = hash;
      }
    };

    const popstateHandler = (): void => {
      // When navigating history (back/forward), ensure we scroll to the current hash
      const currentHash: string = window.location.hash;
      if (currentHash) {
        scrollToHash(currentHash, "auto");
      }
    };

    document.addEventListener("click", clickHandler);
    window.addEventListener("popstate", popstateHandler);

    // On initial load, if there is a hash, scroll to it after layout
    let initialFrame: number | null = null;
    if (window.location.hash) {
      const initialHash: string = window.location.hash;
      initialFrame = window.requestAnimationFrame(() => {
        scrollToHash(initialHash, "auto");
      });
    }

    return () => {
      document.removeEventListener("click", clickHandler);
      window.removeEventListener("popstate", popstateHandler);
      if (initialFrame !== null) {
        window.cancelAnimationFrame(initialFrame);
      }
    };
  }, []);
}


